// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';
// images
import logoPng1x from '../assets/logo/logo@1x.png';
import logoPng2x from '../assets/logo/logo@2x.png';
import logoPng3x from '../assets/logo/logo@3x.png';
import logoPng4x from '../assets/logo/logo@4x.png';

// ----------------------------------------------------------------------

export default function CompanyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <Avatar
      // src={
      //   user?.picture ||
      //   'https://www.pikpng.com/pngl/b/43-430353_dextra-middle-east-fze-construction-activity-office-white.png'
      // }
      color={user?.picture ? 'default' : createAvatar(user?.name).color}
      src={logoPng1x}
      srcSet={`${logoPng1x} 1x, ${logoPng2x} 2x, ${logoPng3x} 3x, ${logoPng4x} 4x`}
      variant={'square'}
      alt={user?.name}
      {...other}
    >
      {createAvatar(user?.name).name}
    </Avatar>
  );
}
